'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getEnv = exports.getDomain = exports.isProduction = exports.isTeam = exports.isStaging = exports.isDevelopment = undefined;

var _domain = require('../config/enums/domain');

var _env = require('../config/enums/env');

var _window = require('../test-helpers/mock/window');

var isDevelopment = exports.isDevelopment = function isDevelopment() {
    return getDomain() === _domain.Domain.DEVELOPMENT;
};
var isStaging = exports.isStaging = function isStaging() {
    return getDomain() === _domain.Domain.STAGING;
};
var isTeam = exports.isTeam = function isTeam() {
    return getDomain() === _domain.Domain.TEAM;
};
var isProduction = exports.isProduction = function isProduction() {
    return !isStaging() && !isDevelopment() && !isTeam();
};
var getDomain = exports.getDomain = function getDomain() {
    var hostName = window.location.hostname;
    var mockDomain = _window.customWindow.mockDomain;
    if (!hostName) {
        return _domain.defaultDomain;
    }
    var hostNameParts = hostName.split('.');
    var domain = mockDomain || hostNameParts[hostNameParts.length - 1];
    if (_domain.supportedDomains.includes(domain)) {
        return domain;
    }
    return _domain.defaultDomain;
};
var getEnv = exports.getEnv = function getEnv() {
    if (isDevelopment()) {
        return _env.Env.DEVELOPMENT;
    }
    if (isTeam()) {
        return _env.Env.TEAM;
    }
    if (isStaging()) {
        return _env.Env.STAGING;
    }
    return _env.Env.PRODUCTION;
};
//# sourceMappingURL=env.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/web-ui/dist/helpers/env.js
// module id = 648
// module chunks = 0